export default __webpack_public_path__ + "static/media/banner5en.eabbfdc9.png";